import {
  NEW_REMINDERS,
} from '../actions/remindersActions';
import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

const initialState = {
  page : []
} // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  
  switch (type) {
    case NEW_REMINDERS:
      newState = { page: payload };
      return { ...state, ...newState };
    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };
    default:
      return state;
  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/remindersReducer.js